/* _____ CUSTOM  _______ */


// Scroll pagina storia [page-id='128955744583']

 document.addEventListener("DOMContentLoaded", () => {

    const mainElement = document.querySelector("main#MainContent[page-id='128955744583']");

    if (mainElement) {
        const heritageSections = document.querySelectorAll("section.shopify-section[id*='category_slider_banner']");

        heritageSections.forEach((section, index) => {
            const uniqueAttribute = `section-${index + 1}`;
            section.setAttribute('data-anchor', uniqueAttribute);

            const anchor = document.createElement('a');
            anchor.id = uniqueAttribute;
            anchor.className = "section_anchor";
            section.prepend(anchor);

            const button = section.querySelector('a.button');
            if (button && index < heritageSections.length - 1) {
                const nextSectionAttribute = `section-${index + 2}`;
                 button.href = `#${nextSectionAttribute}`;
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    document.querySelector(`#${nextSectionAttribute}`).scrollIntoView({ behavior: 'smooth' });
                });
            } else if (button) {
                button.removeAttribute('href');
            }
        });
    }
    // 1. LOGICA PER LA PAGINA CATALOGO / COLLEZIONE
  if (window.location.pathname.includes('/collections/')) {

    // Intercetta i click sui link dei prodotti
    document.addEventListener('click', (event) => {
      const productLink = event.target.closest('a[href*="/products/"]');
      if (productLink) {
        sessionStorage.setItem('last_collection_url', window.location.href);
        sessionStorage.setItem('last_collection_scroll', window.scrollY);
      }
    });
  }

// 2. LOGICA PER LA SCHEDA PRODOTTO
if (window.location.pathname.includes('/products/')) {
  const backBtn = document.getElementById('back-to-catalog-btn');
  if (backBtn) {
    backBtn.style.display = 'flex';
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('#back-to-catalog-btn');

    if (btn) {
      event.preventDefault();

      // Se l'utente proviene da una collezione del nostro sito, usiamo la BFCache (ISTANTANEO)
      if (document.referrer && document.referrer.includes('/collections/')) {
        window.history.back();
      }
      // Fallback: se è entrato da link diretto (Google, Instagram, ecc.), usiamo l'URL salvato o la collezione generale
      else {
        const savedUrl = sessionStorage.getItem('last_collection_url');
        window.location.href = savedUrl ? savedUrl : '/collections/all';
      }
    }
  });
}

    //APP FORMS (page Accesso Archive Private)
    const formMap = {
        "1204569": "form-1",
        "forms-root-1204569": "form-1",
    };
    function applyFormCustomizations(formHost, customLinkHref) {
        if (!formHost.shadowRoot) return;
        const shadow = formHost.shadowRoot;

        // 🎯 legge l'attributo dal container esterno
        const externalContainer = formHost.closest('[data-forms-id]');
        const formsId = externalContainer?.getAttribute('data-forms-id');

        // 🚫 se non è nella mappa, non fa nulla
        if (!formsId || !formMap[formsId]) return;

        // 🎯 trova il container *interno* allo shadowRoot e assegna il data-unic-id
        const internalContainer = shadow.querySelector('#app-embed, div, section, ._formContainer');

        if (internalContainer) {
            internalContainer.setAttribute('data-unic-id', formMap[formsId]);
        }

        // ✅ form-1 — nascondi select e forza selezione prima opzione via promise-based wait
        const selectContainer = shadow.querySelector('[data-unic-id="form-1"] ._selectContainer_12thd_6');
        
        // Il button ha classe _selectToggle_12thd_25, NON aria-controls
        const btn = selectContainer?.querySelector('button._selectToggle_12thd_25');

        if (selectContainer && btn) {
            // Nascondi visivamente il select container se necessario
            // selectContainer.style.display = 'none';

            // Apri il dropdown
            btn.click();

            // Funzione per attendere la listbox (cerca in shadowRoot, body, portal containers)
            const waitForListbox = (shadowRoot, listboxId, timeout = 3000) => {
                return new Promise((resolve) => {
                    const start = Date.now();
                    const escapedId = CSS.escape(listboxId);

                    const check = () => {
                        // 1. Cerca nello shadowRoot
                        let listbox = shadowRoot.querySelector(`#${escapedId}`);

                        // 2. Cerca in document.body (portal comune)
                        if (!listbox) listbox = document.querySelector(`#${escapedId}`);

                        // 3. Cerca in eventuali portal containers Shopify/Polaris
                        if (!listbox) {
                            const portals = document.querySelectorAll(
                                '[data-shopify-forms-portal], [data-polaris-portal], .polaris-portal, [id^="portal-"]'
                            );
                            portals.forEach((p) => {
                                if (!listbox) listbox = p.querySelector(`#${escapedId}`);
                            });
                        }

                        // 4. Fallback: cerca per role="listbox" con l'ID corretto
                        if (!listbox) {
                            listbox =
                                document.querySelector(`[role="listbox"]#${escapedId}`) ||
                                shadowRoot.querySelector(`[role="listbox"]#${escapedId}`);
                        }

                        if (listbox) {
                            // Attendi che le opzioni siano renderizzate e pronte per il click
                            const waitForOptionsReady = (lb) => {
                                return new Promise((resolve) => {
                                    const start = Date.now();
                                    const checkOptions = () => {
                                        const option = lb.querySelector('[role="option"]:not([aria-disabled="true"])');
                                        if (option) {
                                            resolve(lb);
                                            return;
                                        }
                                        if (Date.now() - start > 1000) {
                                            resolve(lb);
                                            return;
                                        }
                                        requestAnimationFrame(checkOptions);
                                    };
                                    requestAnimationFrame(checkOptions);
                                });
                            };
                            waitForOptionsReady(listbox).then(resolve);
                            return;
                        }

                        if (Date.now() - start > timeout) {
                            resolve(null);
                            return;
                        }

                        requestAnimationFrame(check);
                    };

                    requestAnimationFrame(check);
                });
            };

            // Funzione per trovare la prima opzione selezionabile
            const findFirstOption = (listbox) => {
                const selectors = [
                    '[role="option"]:not([aria-disabled="true"])',
                    '._optionListItem_12thd_102 > [role="option"]',
                    '._optionListItem_12thd_102 > div[role="option"]',
                    'button[role="option"]',
                    'li[role="option"] button',
                    '[data-value] button',
                    'li button',
                    '._optionListItem_12thd_102 > *',
                ];

                for (const sel of selectors) {
                    const option = listbox.querySelector(sel);
                    const isOptionRole = option?.getAttribute?.('role') === 'option';
                    const isVisible = isOptionRole || (option && option.offsetParent !== null);
                    if (option && isVisible) {
                        return option;
                    }
                }
                return null;
            };

            // Esegui selezione
            waitForListbox(shadow, 'custom#archive_private-selector-dropdown', 3000)
                .then((listbox) => {
                    if (!listbox) return;

                    const firstOption = findFirstOption(listbox);
                    if (firstOption) {
                        firstOption.click();
                    }
                })
                .catch((err) => console.error('[Forms] Errore selezione opzione:', err));
        }

        const privacyLink = '/policies/privacy-policy';
        const privacyEl = shadow.querySelector("._checkboxField_1hja3_3 span._textBody_2aowh_10");
        if (privacyEl) {
            let html = privacyEl.innerHTML;
            html = html.replace(/l'informativa della privacy/giu,
                `<a href="${privacyLink}" target="_blank" rel="noopener">l'informativa della Privacy</a>`
            );
            html = html.replace(/privacy policy/giu,
                `<a href="${privacyLink}" target="_blank" rel="noopener">Privacy Policy</a>`
            );
            privacyEl.innerHTML = html;
        }

        const linkTag = document.createElement('link');
        linkTag.rel = 'stylesheet';
        linkTag.href = customLinkHref;
        shadow.prepend(linkTag);
    }

    function initAllForms() {
        const customCSS = AF?.chunks?.customCSS;
        const forms = document.querySelectorAll('shopify-forms-embed');
        forms.forEach(formHost => {
            applyFormCustomizations(formHost, customCSS);
        });
    }

    let elapsed = 0;
    const waitShadow = setInterval(() => {
        elapsed += 100;
        if (elapsed > 5000) {
            clearInterval(waitShadow);
        }
        const first = document.querySelector('shopify-forms-embed');
        if (first?.shadowRoot) {
            initAllForms();
            clearInterval(waitShadow);
        }
    }, 100);

});


    // RIPRISTINO SCROLL IMMEDIATO PRIMA DEL DIPINTO SCHERMO (Paint)
window.addEventListener('pageshow', () => {
  if (window.location.pathname.includes('/collections/')) {
    const savedScroll = sessionStorage.getItem('last_collection_scroll');

    if (savedScroll !== null) {
      // Disattiva smooth scroll temporaneamente
      const originalScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';

      // requestAnimationFrame garantisce che lo scroll avvenga nello stesso frame di rendering
      requestAnimationFrame(() => {
        window.scrollTo({
          top: parseInt(savedScroll, 10),
          left: 0,
          behavior: 'instant'
        });

        // Ripristina il comportamento originale
        document.documentElement.style.scrollBehavior = originalScrollBehavior;

        // Puliamo lo storage solo DOPO che lo scroll è stato applicato
        sessionStorage.removeItem('last_collection_scroll');
      });
    }
  }
});

/* ===== Altezza uniforme .card__heading (solo visibili) dentro .featured-blog-swiper ===== */
(function () {
  function equalizeSwiperHeadings(swiper) {
    // Solo gli heading effettivamente visibili (display:none => offsetParent null)
    const headings = Array.from(swiper.querySelectorAll('.card__heading'))
      .filter((h) => h.offsetParent !== null);

    if (!headings.length) return;

    // Reset, per misurare l'altezza naturale
    headings.forEach((h) => (h.style.minHeight = ''));

    // Trova il massimo
    let max = 0;
    headings.forEach((h) => {
      max = Math.max(max, h.getBoundingClientRect().height);
    });

    // Applica a tutti
    if (max > 0) {
      headings.forEach((h) => (h.style.minHeight = max + 'px'));
    }
  }

  function initAll() {
    document.querySelectorAll('.featured-blog-swiper').forEach(equalizeSwiperHeadings);
  }

  // Debounce per il resize
  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    // Ricalcola quando i font web sono caricati (cambiano l'andata a capo)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initAll);
    }
  });

  window.addEventListener('load', initAll);
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);
  document.addEventListener('shopify:section:load', initAll);
})();


// /**
//  * * Funzione che legge i cookie in base ad un nome specifico
//  * @param {string} name
//  * @returns
//  */
// function getCookie(name) {
//     let value = `; ${document.cookie}`;
//     let parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(';').shift();
// }

// function deleteCookie( name, path, domain ) {
//   if( get_cookie( name ) ) {
//     document.cookie = name + "=" +
//       ((path) ? ";path="+path:"")+
//       ((domain)?";domain="+domain:"") +
//       ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
//   }
// }
// /**
//  * Questa cosa serve per creare una customization per Refrigiwear
//  * dove puo aggiungere uno sconto in piu su certi articoli presenti in una certa pagine.
//  * * Il meccanismo funziona con un codice sconto aggiunto su certi prodotto / collection che però vale solo se
//  * * provengono da un link preciso.
//  *
//  * * Siccome shopify non fa vedere che c'é un abbassamento del prezzo é stata creata questa funzione cunstom per la visualizzazione
//  * * del prezzo abbassato.
// */

// document.addEventListener('DOMContentLoaded', function() {

//     if(!IS_EXTRA_SALE_ACTIVE) {
//       const discount_code = getCookie('discount_code')

//       if(discount_code){
//         deleteCookie(discount_code)
//       }

//       return
//     }


//     // VARIABILI utilizzati durante questo processo
//     const CONFIG_VARIABLES = [
//         {
//             discountPercentage: 0.40,
//             discountCodeName: "SALE40",
//             collectionNames: ["exclusive-summer-sale"],
//             cookieExpiryDate:  "2025-07-04T18:00:00Z"
//         },
//         {
//             discountPercentage: 0.10,
//             discountCodeName: "EXTRA10SALE",
//             collectionNames: ["secret-summer-sale-deals"],
//             cookieExpiryDate:  "2025-11-01T12:00:00Z"
//         }
//     ]

// // il link sharable deve essere costruito così:
// // https://refrigiwear1954.com/discount/[discountCodeName]?redirect=%2Fcollections%2F[collectionNames]

// // ESEMPIO: https://refrigiwear1954.com/discount/10SECRET?redirect=%2Fcollections%2Fsecret-deals
// // ESEMPIO: https://refrigiwear1954.com/discount/PVL10?redirect=%2Fcollections%2Fprivalia-secret-deals


// https://refrigiwear1954.com/discount/FIRST10?redirect=%2Fcollections%2Fblack-friday

//     // /**
//     //  * *Funzione che setta i cookie (FORSE NON SERVE)
//     //  * @param {string} name
//     //  * @param {string} value
//     //  * @param {string} days
//     //  */
//     // function setCookie(name, value, days) {
//     //     let expires = '';
//     //     if (days) {
//     //         let date = new Date();
//     //         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//     //         expires = `; expires=${date.toUTCString()}`;
//     //     }
//     //     document.cookie = `${name}=${(value || '')}${expires}; path=/`;
//     // }

//     /**
//      * Function that waits for an element to appear in the DOM and then executes a callback function.
//      * @param {string} selector - The CSS selector of the element to wait for.
//      * @param {function} callback - The function to execute once the element is found.
//     */
//     function waitForElement(selector, callback){
//         let poops = setInterval(function(){
//             if(document.querySelector(selector)){
//                 clearInterval(poops);
//                 callback();
//             }
//         }, 100);
//     }

//     /**
//      * * Funzione che cambia il prezzo in un element con il prezzo scontato da un altro element
//      * @param {Element} priceContainer
//      * @param {Element} previousPriceEl
//     */
//     function fromPreviousToNew(priceContainer, previousPriceEl, percentage){
//         // estrai il prezzo dall'element e transformalo in float
//         let previousPrice = parseFloat(extractNumber(previousPriceEl.textContent).replace(',','.'))

//         // sottrai la percentuale
//         const previousPriceSubstracted = subtractPercentage(previousPrice, percentage)

//         //initializza l'elemento dove verra sostituito il prezzo
//         const newPriceContainer = priceContainer.querySelector(".price__sale .price-item.price-item--sale.price-item--last")
//         // salva la currency di prima
//         const currencySymbol = newPriceContainer.textContent.match(/[^\s\n0-9.,]+/g)[0];

//         // sostituisci il prezzo nel sale con quello nuovo e aggiungi la currency € + 100
//         newPriceContainer.innerText = currencySymbol + parseFloat(previousPriceSubstracted).toFixed(2).replace('.',",")

//     }


//     /**
//      * * Funzione per estrare dalla stringa il numero con regex
//      * @param {string} stringToExtractFrom
//      * @returns
//     */
//     function extractNumber(stringToExtractFrom) {
//         const numbers = stringToExtractFrom.match(/[0-9.,]+/g);
//         return numbers ? numbers.join('') : '';
//     }

//     /**
//      * *Funzione che sottrae dal prezzo dato la percentuale prestabilita
//      *
//      * @param {number} price
//      * @param {number} percentage
//      * @returns
//      */
//     function subtractPercentage(price, percentage){
//         return price * (1 - percentage)
//     }


//     /**
//      * * Funzione che crea un badge con la percentuale dato
//      * @param {Element} badge
//      * @param {number} discountPercentage
//      * @returns
//     */
//     function changeBadgePercentage(badgesSelector, config){
//         //  leggi tutti i badge presenti nella pagina che caricano dopo
//         const badges = document.querySelectorAll(badgesSelector+":has(span.badge)")
//         const { discountPercentage } = config

//         const createBadge = (badge, discountPercentage) => {
//             let badgeSpan = document.createElement("span")
//             badgeSpan.className = "badge badge--bottom-left AF_sale-badge"
//             badgeSpan.innerText = `-${(discountPercentage * 100)}%`

//             badge.appendChild(badgeSpan)
//         }

//         if(badges.length > 0){
//             // per ogni badge...
//             badges.forEach((badgeContainer)=>{
//                 // se ha figli...
//                 if(badgeContainer.hasChildNodes()){
//                     // seleziona lo span
//                     let badge = badgeContainer.querySelector("span.badge");

//                     // e sostituisci con la nuova percentuale + quella precedente
//                     badge.innerText = `-${(discountPercentage * 100) + parseInt(extractNumber(badge.textContent))}%`;
//                 }else {
//                     // crea un badge con la percentuale
//                     createBadge(badgeContainer, discountPercentage)
//                 }
//             })
//         } else{ // se non ci sono badge da modificare prendi il selettore alternativo e crea un badge
//             let alternativeBadges = document.querySelectorAll(badgesSelector)

//             for(let badge of alternativeBadges){
//                 createBadge(badge, discountPercentage)
//             }
//         }
//     }

//     function changeProductPrice(pricesSelector, config){
//         // salva tutti i prezzi trovati sulla pagina
//         const getAllPrices = document.querySelectorAll(pricesSelector)
//         const { discountPercentage } = config
//         // per ogni prezzo trovato sulla pagina...
//         getAllPrices.forEach(priceContainer => {

//             // se é un prezzo giá scontato...
//             if(priceContainer.classList.contains('price--on-sale')){
//                 // prendi il prezzo originale gia scontato
//                 const previousPriceEl = priceContainer.querySelector(".price__container .price__sale .price-item.price-item--sale.price-item--last")
//                 // e fai partire la funzione per lo sconto aggiuntivo
//                 fromPreviousToNew(priceContainer, previousPriceEl, discountPercentage)
//             }else{
//                 // altrimenti non é un prezzo scontanto...
//                 // prendi il prezzo non scontato (quello originale)
//                 const previousPriceEl = priceContainer.querySelector(".price__container .price__regular .price-item.price-item--regular")
//                 // fai partire la funzione per aggiungere lo sconto
//                 fromPreviousToNew(priceContainer, previousPriceEl, discountPercentage)

//                 // initializza il regular price dentro il contenitore degli sconti
//                 const regularSalePrice = priceContainer.querySelector(".price__container .price__sale .price-item.price-item--regular")

//                 // e di conseguenza sostituisci lo 0 con il prezzo initiale del prodotto
//                 if(regularSalePrice) regularSalePrice.innerText = previousPriceEl.textContent.trim()

//                 // e inserisci la classe dello sconto per renderlo visibile
//                 priceContainer.classList.add("price--on-sale")
//             }

//         });
//     }


//     // salva il codice sconti in una variabile
//     const discountCode = getCookie('discount_code');

//     if (discountCode) {
//         // Set a fixed expiration date for the cookie
//         const fixedExpiryDate = new Date('2023-12-31T23:59:59Z'); // Set your desired fixed date here
//         document.cookie = `discount_code=${discountCode}; expires=${fixedExpiryDate.toUTCString()}; path=/`;
//     }

//     CONFIG_VARIABLES.forEach((config) => {

//         // se l'utente NON ha il cookie salvato del codice sconto non facio partire il codice
//         if(discountCode !== config.discountCodeName) return


//         // se il codice sconto é uguale a quello prestabilito...
//         if (discountCode === config.discountCodeName) {
//             // init del valore del cookie
//             const cookieValue = document.cookie.split('; ').find(row => row.startsWith('discount_code='));
//             // se il cookie esiste...
//             if (cookieValue) {
//                 // creo un array con i dati del cookie
//                 const cookieParts = cookieValue.split('=');
//                 // leggo la data di scadenza del cookie
//                 const cookieExpiry = cookieParts[1].split(';').find(part => part.trim().startsWith('expires='));
//                 // se esiste la data di scadenza...
//                 if (cookieExpiry) {
//                     // leggo la data di scadenza del cookie
//                     const existingExpiryDate = new Date(cookieExpiry.split('=')[1]);
//                     // init della data di scadenza prestabilita dal config
//                     const configExpiryDate = new Date(config.cookieExpiryDate);
//                     // se la data di scadenza del cookie é uguale a quella prestabilita dal config...
//                     if (existingExpiryDate.getTime() === configExpiryDate.getTime()) {
//                         // non fare niente
//                         console.log('Cookie already has the same expiration date set.');
//                         return;
//                     }
//                 }
//             }

//             // setta la data di scadenza del cookie con la data di scadenza prestabilita dal config
//             const fixedExpiryDate = new Date(config.cookieExpiryDate);
//             // setta il cookie con la data di scadenza prestabilita dal config
//             document.cookie = `discount_code=${discountCode}; expires=${fixedExpiryDate.toUTCString()}; path=/`;
//         }

//         /*#### ON PRODUCT PAGE ####*/
//         // seleziona lo script del prodotto per estrarre i dati
//         const scriptProductDataEl = document.querySelector("#productJsonData")
//         // se l'utente sta su una path che include ls parola "products" e l'element script con l'id esiste...


//         if(window.location.pathname.includes("products") && scriptProductDataEl){
//             // prendo i dati dallo script in formato json
//             const scriptProductData = JSON.parse(scriptProductDataEl.innerHTML)

//             // se il prodotto NON fa parte della collection voluta non faccio aprtire il codice
//             if(!scriptProductData.collections.some(coll => (config.collectionNames.includes(coll)))) return

//             //  leggi i badge del prodotto main
//             changeBadgePercentage(".AF_product_badge", config)
//             changeProductPrice('div.price', config)


//             // ONLY FOR THE PRODUCT PAGE
//             if(document.querySelector('.product'))
//                 // FOR THE COMPLEMENTARY CARDS IN PRODUCT
//                 waitForElement('.complementary-products__container', ()=>{
//                     setTimeout(()=>{
//                         changeBadgePercentage(".complementary-products__container .card__badge", config)
//                     })
//                 })

//             // FOR related products swiper
//             waitForElement('.related-products .swiper', ()=>{
//                 setTimeout(()=>{
//                     changeBadgePercentage(".related-products .card__badge", config)
//                 }, 3000)

//                 setTimeout(()=>{
//                     changeProductPrice('.related-products .card-information .price', config)
//                 }, 3000)
//             })
//         }

//         /*#### ON COLLECTION ####*/
//         // se l'utente sta nella collection giusta allora fai partire tutta la logica
//         for(let collection of config.collectionNames){
//             if(window.location.pathname.includes(collection)) {
//                 changeBadgePercentage('.card__badge', config)
//                 changeProductPrice("div.price", config)
//                 console.log("discount added")
//                 break
//             }
//         }
//     })
// });



/* B2B TO B2C PAGINE COLLAB */

const params = new URLSearchParams(window.location.search);
if (params.get("from") === "prestashop") {
  document.addEventListener("DOMContentLoaded", function() {
    const announcement = document.querySelector("section.announcement-bar-section");
    const header = document.querySelector("section.section-header");
    const stickyHeaders = document.querySelectorAll("sticky-header");
    const footers = document.querySelectorAll(".shopify-section-group-footer-group");

    header.style.display = "none";
    announcement.style.display = "none";
    document.body.style.paddingBottom = "0";

    stickyHeaders.forEach(header =>{
      header.style.display = "none";
    });

    footers.forEach(footer => {
      footer.style.display = "none";
    });
  });
}

/*DENIM COLLECTION*/

// 1. Controllo se siamo nella collezione corretta
/*     const mainElement = document.querySelector('main[collection-id="643556770119"]'); */     //DENIM ID
/*     const mainElement = document.querySelector('main[collection-id="664311529799"]');        //FLASH SALE ID
    if (!mainElement) return;

    // 2. Applichiamo l'opacità 0.6 a tutti i grid-item nel container denim
    const gridItems = document.querySelectorAll('.AF-menu-denim .AF_grid-item');
    gridItems.forEach(item => {
        item.style.opacity = '0.6';
        item.style.transition = 'opacity 0.3s ease';
    });

    // 3. Logica dinamica per i filtri
    const urlParams = new URLSearchParams(window.location.search);
    const fitFilter = urlParams.get('filter.p.m.custom.fit'); // Recupera il valore dopo l'uguale

    if (fitFilter) {
        // Convertiamo il valore in minuscolo per sicurezza (es: REGULAR -> regular)
        const fitValue = fitFilter.toLowerCase();

        // Selezioniamo gli elementi che hanno la classe corrispondente (es: .denim-regular)
        const targetClass = `.denim-${fitValue}`;
        const activeItems = document.querySelectorAll(`.AF-menu-denim .AF_grid-item${targetClass}`);

        // Portiamo l'opacità a 1 per i match trovati
        activeItems.forEach(item => {
            item.style.opacity = '1';
        });
    } */
